import React from "react";
import moment from "moment";
import { component_tool } from '@/tool'
import { AudioControl } from "@/containers/common";
let { WizDataTable, WizButton } = component_tool

//配置项
const componentName = "smartPhone";

function columns(self, entityType) {
  return [
    {
      name: "id",
    },
    {
      title: "呼叫方",
      name: "callingName",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "联系时间",
      name: "createTime",
      searchItem: {
        type: 'date~'
      },
    },
    {
      title: "联系时间",
      name: "contactTime",
      tableItem: {
        width: 200,
        render: (text) => moment(text).format('YYYY-MM-DD HH:mm')
      },
    },
    {
      title: "联系人",
      name: "contactName",
      searchItem: !self.props.innerQues?{}:null,
    },
    {
      title: "联系人姓名",
      name: "contactName",
      tableItem: !self.props.innerQues?{}:null,
    },
    {
      title: "联系人账号",
      name: "contactUser",
      tableItem: !self.props.innerQues?{}:null,
    },
    {
      title: "致电场景",
      name: "callScene",
      tableItem: !self.props.innerQues&&(entityType == 2 || entityType == 3 || entityType == 6) ? {
        render: (text, record) => {
          return (
            <span>{text == 1 ? '列表用户拨打' : '问卷内拨打'}</span>
          )
        }
      } : null,
    },
    {
      title: "关联题目序号",
      name: "ltemNumber",
      tableItem: !self.props.innerQues&&(entityType == 2 || entityType == 3 || entityType == 6) ? {
        render: (text, record) => {
          return (
            <div style={{ textAlign: 'center' }}>
              <a onClick={() => self.lookQuesDetail(record)}>{text && text != -1 ? text : ''}</a>
            </div>
          )
        }
      } : null,
    },
    {
      title: "通话录音",
      name: "yuntelRecordFileList",
      tableItem: {
        render: (text, record) => {
          return (
            <AudioControl audioList={text}></AudioControl>
          )
        }

      },
    },
    {
      title: "备注",
      name: "remark",
      searchItem: {},
      tableItem: {},
    },
  ];
}

function templateConfig(self, entityType) {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(self, entityType),
        btnAccessCheck: false,
        searchBarProps: {
          cols: {
            xs: 24,
            md: 12,
            xl: 12
          },
          buttonSort:!self.props.innerQues? ['export']:[],
          buttons: [
            {
              key: "export",
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "personInfoExport",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
          ],
          dataFormat: (val) => {
            let { createTime } = val
            if (createTime && createTime.length) {
              if (createTime[0]) {
                val['contactStartDate'] = moment(createTime[0]).format("YYYY-MM-DD HH:mm:ss")
              }
              if (createTime[1]) {
                val['contactEndDate'] = moment(createTime[1]).format("YYYY-MM-DD HH:mm:ss")
              }
            }
            return val
          },
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          isScroll: true,
          loading: false,
          bordered: true,
        },
      },
    },
  };
}

const apis = (entityType, entityId, parentEntityId,applySurveyId,entityTypeNew,entityTypeList) => {
  return {
    list: {
      path: `${componentName}/getYunTelRecordPageList`,
      payload: {
        key: `${componentName}@getYunTelRecordPageList`,
        apiParams: { pageNum: 1, pageSize: 10, entityType, entityId, parentEntityId,applySurveyId,entityTypeNew,entityTypeList},
      },
    },
    personInfoExport: {
      path: `${componentName}/getYunTelRecordList`,
      payload: {
        key: `${componentName}@getYunTelRecordList`,
        apiParams: {}
      }
    },
  }

};

let reduxTemplateCofig = (args) => {
  let { entityType, entityId, parentEntityId,applySurveyId,entityTypeNew,entityTypeList } = args
  return {
    apis: apis(entityType, entityId, parentEntityId,applySurveyId,entityTypeNew,entityTypeList),
    componentName,
    initApiKeys: ["list"],
    needLoading: true,
    keepInitApiParams: true,
    ...args,
  };
};

export { reduxTemplateCofig, templateConfig };
